import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { isCosmosEnabled, getFields } from "../api/cosmos-api";

const useCosmosFields = () => {
  const [fields, setFields] = useState([]);

  const { isLoading: clientExistsLoading, data: clientExists } = useQuery(
    ["cosmos-client-exists"],
    isCosmosEnabled,
    {
      retry: 0,
      select: (response) => {
        const { data } = response;
        return data;
      },
    }
  );

  const { isLoading: fieldsLoading, data: fieldsData } = useQuery(
    ["cosmos-fields"],
    getFields,
    {
      enabled: !clientExistsLoading && clientExists,
      retry: 0,
      select: (response) => {
        const { data } = response;
        const formattedFields = data.map((field) => ({
          label: field.title,
          value: field.id,
          fieldProps: field,
        }));
        return formattedFields;
      },
    }
  );

  useEffect(() => {
    if (!fieldsLoading && fieldsData) {
      setFields([...fieldsData]);
    }
  }, [fieldsData, fieldsLoading]);

  return {
    isLoading: fieldsLoading,
    fields,
  };
};

export default useCosmosFields;
